import { render } from "./StoreRankingDetails.vue?vue&type=template&id=f94c46a2"
import script from "./StoreRankingDetails.vue?vue&type=script&lang=js"
export * from "./StoreRankingDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__